import { render, staticRenderFns } from "./failure.vue?vue&type=template&id=2af57bda&scoped=true&"
import script from "./failure.vue?vue&type=script&lang=js&"
export * from "./failure.vue?vue&type=script&lang=js&"
import style0 from "./failure.vue?vue&type=style&index=0&id=2af57bda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af57bda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VApp,VBtn,VFlex,VIcon,VLayout,VSnackbar})
